import { render, staticRenderFns } from "./AdminUserMenu.vue?vue&type=template&id=10d948cc"
import script from "./AdminUserMenu.vue?vue&type=script&lang=js"
export * from "./AdminUserMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports